"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMediaVisualizationQueryDto = void 0;
const cursor_pagination_1 = require("../cursor-pagination");
class SearchMediaVisualizationQueryDto extends cursor_pagination_1.CursorPaginationOptions {
    displayIds;
    mediaIds;
    mediaCampaignIds;
    from;
    to;
}
exports.SearchMediaVisualizationQueryDto = SearchMediaVisualizationQueryDto;
